import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class RestService {

  protected readonly BASE_URL: string = environment.base_url;

  constructor(protected _http: HttpClient) {
  }

  get getBaseUrl() {
      return this.BASE_URL;
  }

  GetAuthHeader() {
      //when ever make changes in this method pls make same changes in ValidationService.ts 's  same method
      let token = '';
      let token_Expiry = localStorage.getItem("auth_token_expiry");
      var user = JSON.parse(localStorage.getItem("currentUser"));

      if (user != null && (!token_Expiry || new Date(token_Expiry) < new Date())) {
          console.log('token_Expiry=' + token_Expiry);
          localStorage.setItem('auth_token_expiry', this.GetTokenExpiryDate().toString());
          let date = token_Expiry;
          this.GETNoAuth('user/refreshToken/' + user.Id).subscribe(res => {
              localStorage.setItem('auth_token', res.toString());
              return this.setToken(token);
          }, error => {
              localStorage.setItem('auth_token_expiry', date);
          });
      }
      else {
          return this.setToken(token);
      }
  }

  setToken(token) {
      if (localStorage.getItem("auth_token") !== null) {
          token = localStorage.getItem('auth_token');
      }

      const httpOptions = {
          headers: new HttpHeaders({
              "Authorization": "Bearer " + token
          })
      };
      return httpOptions;
  }

  GetTokenExpiryDate() {
      return this.DateAdd(new Date(), environment.jwtTokenExpiry);
  }

  DateAdd(date: Date, days: number): Date {
      var newdate = new Date(date);
      newdate.setDate(newdate.getDate() + (days));
      return newdate;
  }

  GETNoAuth(url: string): Observable<any[]> {
      const requestUrl = `${this.BASE_URL}/${url}`;
      return this._http.get<any[]>(requestUrl);
  }

  GET(url: string): Observable<any[]> {
      //const requestUrl = `${this.BASE_URL}/${url}`;
      //return this._http.get<any[]>(requestUrl)
      const requestUrl = `${this.BASE_URL}/${url}`;
      const httpOptions = this.GetAuthHeader();
      return this._http.get<any[]>(requestUrl, httpOptions)
  }

  get<T>(url: string): Observable<T> {
      const requestUrl = `${this.BASE_URL}/${url}`;
      const httpOptions = this.GetAuthHeader();
      return this._http.get<T>(requestUrl, httpOptions)
  }

  post<T>(url: string, postData: any): Observable<T[]> {
      const requestUrl = `${this.BASE_URL}/${url}`;
      const httpOptions = this.GetAuthHeader();
      return this._http.post<T[]>(requestUrl, postData, httpOptions)
  }

  deleteService<T>(url: string): Observable<T[]> {
      const requestUrl = `${this.BASE_URL}/${url}`;
      const httpOptions = this.GetAuthHeader();
      return this._http.delete<T[]>(requestUrl, httpOptions)
  }

  postForEntityObject<T>(url: string, postData: any): Observable<T> {
      const requestUrl = `${this.BASE_URL}/${url}`;
      const httpOptions = this.GetAuthHeader();
      return this._http.post<T>(requestUrl, postData, httpOptions)
  }

  delete<T>(url: string): Observable<T> {
      const requestUrl = `${this.BASE_URL}/${url}`;
      const httpOptions = this.GetAuthHeader();
      return this._http.delete<T>(requestUrl, httpOptions)
  }

  private handleError(err: HttpErrorResponse) {
      console.log('http error occurred');
      console.log(err.message);
      return throwError(err.message);
  }
}
